import { useSite } from "@/contexts/SiteContext";
import { ChevronRight, XCircle } from "lucide-react";

export default function Method() {
  const { sectionContent } = useSite();
  const c = sectionContent("method");
  if (!c) return null;
  const pillars = Array.isArray(c.pillars) ? c.pillars : [];
  const notItems = Array.isArray(c.not_items) ? c.not_items : [];

  return (
    <section data-testid="method-section" className="py-14 sm:py-20 lg:py-28" style={{ background: "var(--ct-bg)" }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-14 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-3 sm:mb-4">
            <span className="gold-rule" />
            <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Cum funcționează"}</span>
            <span className="gold-rule" />
          </div>
          <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight">{c.title || "O combinație între tehnică, intuiție și har"}</h2>
          {c.body && <p data-el="body" data-field="body" className="text-sm sm:text-base lg:text-lg leading-relaxed mt-3 sm:mt-4" style={{ color: "var(--ct-text-muted)" }}>{c.body}</p>}
        </div>
        {pillars.length > 0 && (
          <div className={`grid grid-cols-1 sm:grid-cols-2 ${pillars.length >= 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"} gap-3 sm:gap-4 lg:gap-6 items-stretch relative`}>
            {pillars.map((p, i) => (
              <div key={i} className="relative" data-testid={`method-pillar-${i}`}>
                <div className="card-premium p-5 sm:p-6 lg:p-7 h-full text-center flex flex-col items-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mb-3 sm:mb-4 font-serif text-lg sm:text-xl"
                    style={{ background: "var(--ct-emerald)", color: "var(--ct-gold)", border: "1.5px solid var(--ct-gold)" }}>
                    {i + 1}
                  </div>
                  <h3 data-el="item_title" data-field={`pillars.${i}.title`} className="font-serif text-lg sm:text-xl lg:text-2xl mb-1.5 sm:mb-2 leading-tight">{p.title}</h3>
                  <p data-el="item_body" data-field={`pillars.${i}.desc`} className="text-[13px] sm:text-sm leading-snug sm:leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>{p.desc}</p>
                </div>
                {/* Connector arrow on desktop (not on last item) */}
                {i < pillars.length - 1 && (
                  <div className="hidden lg:flex absolute top-1/2 -right-3 -translate-y-1/2 z-10 w-6 h-6 rounded-full items-center justify-center"
                    style={{ background: "var(--ct-bg)", border: "1.5px solid var(--ct-gold)" }}>
                    <ChevronRight size={14} style={{ color: "var(--ct-gold)" }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        {notItems.length > 0 && (
          <div className="mt-10 sm:mt-14 max-w-2xl mx-auto card-premium p-6 sm:p-8" data-testid="method-not-items">
            <h3 data-el="item_title" data-field="not_title" className="font-serif text-xl sm:text-2xl text-center mb-5">
              {c.not_title || "Ce NU este acest proces"}
            </h3>
            <ul className="space-y-3">
              {notItems.map((it, i) => (
                <li key={i} className="flex items-start gap-3" data-testid={`method-not-item-${i}`}>
                  <XCircle size={18} className="mt-0.5 shrink-0" style={{ color: "var(--ct-danger)" }} />
                  <span data-el="item_body" data-field={`not_items.${i}`} className="text-sm sm:text-base leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </section>
  );
}
